import { FocusEvent, KeyboardEvent, PointerEvent, useRef } from "react";
import { Props, Slider } from "./ContinuousSlider.Parts";

export const ContinuousSlider = ({ ...props }: Props) => {
  const sliderRef = useRef<HTMLSpanElement>(null);

  // #region Handler Functions
  const handlePointerDown = (ev: PointerEvent<HTMLSpanElement>) => {
    if (sliderRef.current) {
      sliderRef.current.dataset.pointer = "true";
    }
    props.onPointerDown?.(ev);
  };

  const handleKeyDown = (ev: KeyboardEvent<HTMLSpanElement>) => {
    delete sliderRef.current?.dataset.pointer;
    props.onKeyDown?.(ev);
  };

  const handleBlur = (ev: FocusEvent<HTMLSpanElement>) => {
    if (!sliderRef.current?.contains(ev.relatedTarget as HTMLElement)) {
      delete sliderRef.current?.dataset.pointer;
    }
    props.onBlur?.(ev);
  };
  // #endregion

  return (
    <Slider
      {...props}
      data-disabled={props.disabled}
      onPointerDown={handlePointerDown}
      onKeyDown={handleKeyDown}
      onBlur={handleBlur}
    />
  );
};
